export const RESET_COMPANY = "RESET_COMPANY";

export const API_ERROR = "COMPANY_API_ERROR";

export const GET_COMPANY = "GET_COMPANY";
export const SET_COMPANY = "SET_COMPANY";

export const EDIT_COMPANY = "EDIT_COMPANY";
export const EDIT_COMPANY_SUCCESS = "EDIT_COMPANY_SUCCESS";
